const isClick = (event) => {
    if (event instanceof KeyboardEvent) {
        const { code } = event;
        if (code === 'Space' || code === 'Enter') {
            return true;
        }
    }
    else if (event instanceof MouseEvent) {
        if (event.button === 0) { // Check if left mouse button was clicked
            return true;
        }
    }
    return false;
};
export default isClick;
// link.addEventListener("click", handleLinkClick);
// link.addEventListener("keypress", handleLinkClick);
// function handleLinkClick(event){
//   if (isClick(event) === true) {
//     event.preventDefault();
//   };
// };
